import * as Yup from 'yup';
import { FormErrorMessages, nameSchema } from 'utils/formValidation';
import { DataLists } from 'services/data/data.types';
import { InformativeReunionStatus } from 'services/person/person.types';

export const updateProjectEventSchema = (datalists: DataLists) => {
    return Yup.object().shape({
        firstname: nameSchema,
        lastname: nameSchema,
        department: Yup.string()
            .oneOf(Object.keys(datalists?.departments || {}), FormErrorMessages.department_invalid)
            .optional(),
        phone: Yup.string()
            .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, FormErrorMessages.phone_invalid)
            .required(FormErrorMessages.required),
        email: Yup.string().email(FormErrorMessages.email_invalid).optional(),
        genre: Yup.string()
            .oneOf(Object.keys(datalists?.person_genres || {}), FormErrorMessages.genre_invalid)
            .optional(),
        born_date: Yup.string()
            .matches(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, FormErrorMessages.born_date_invalid)
            .optional(),
        address: Yup.object({
            address: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            address_add: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            city: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            zipcode: Yup.string()
                .matches(/^\d{5}$/, FormErrorMessages.zipcode_invalid)
                .optional(),
            country: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional()
        }).optional(),
        informative_reunion: Yup.object({
            done: Yup.boolean(),
            date: Yup.string()
                .matches(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, FormErrorMessages.informative_reunion_date_invalid)
                .optional(),
            location: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            status: Yup.string().oneOf(Object.values(InformativeReunionStatus), FormErrorMessages.informative_reunion_status_invalid).optional(),
            supervisor: Yup.mixed().optional(),
            department: Yup.string()
                .oneOf(Object.keys(datalists?.departments || {}), FormErrorMessages.informative_reunion_department_invalid)
                .optional()
        }),
        responsible_person: Yup.mixed().optional(),
        source: Yup.string()
            .oneOf(Object.keys(datalists?.person_sources || {}), FormErrorMessages.source_invalid)
            .optional()
    });
};
